import styled, {css} from 'styled-components';

import {mixins} from '@edna/components/styles';
import {default as BaseCloseIcon} from '@edna/icons/close.svg';

import {Message as BaseMessage} from '../style';
import {MAX_MESSAGE_WIDTH} from '../utils';

export const ButtonIcon = styled.svg`
  ${mixins.wh('16px')}
  flex-shrink: 0;
  margin-right: ${({theme}) => theme.spacing.s2};
`;

type THeaderBackgroundProps = {
  isFullHeight?: boolean;
};

export const HeaderBackground = styled.div<THeaderBackgroundProps>`
  ${mixins.flexAlign('center')}
  background-color: #f3f9fd;
  width: 100%;
  ${({theme: {borderRadius}, isFullHeight}) => css`
    height: ${isFullHeight ? 'auto' : '160px'};
    border-radius: ${borderRadius.br3};
  `}
`;

export const TextBodyHeader = styled.div`
  ${mixins.f3}
  font-weight: 600;
  white-space: pre-wrap;
`;

export const ButtonList = styled.div`
  ${mixins.stack({align: 'end'})};
  width: 100%;
`;

export const Button = styled.div`
  ${mixins.wh('100%', '40px')}
  ${mixins.flexAlign('center')}
  ${mixins.f3};
  position: relative;
  font-weight: 500;
  max-width: ${MAX_MESSAGE_WIDTH};
  word-break: break-word;

  &:first-child::before {
    height: 2px;
  }

  ${({theme}) => css`
    color: ${theme.palette.whatsAppButton};
    background-color: ${theme.branding.backgrounds.primary};
    border-radius: ${theme.borderRadius.br2};

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -8px;
      width: calc(100% + 16px);
      height: 1px;
      background-color: ${theme.palette.grey100};
    }
  `}
`;

export const Footer = styled.span`
  ${mixins.f2};
  display: inline-block;
  ${({theme}) => css`
    margin-top: ${theme.spacing.s1};
    color: ${theme.branding.content.tertiary};
  `}
`;

export const Text = styled.div`
  display: inline-block;
  width: 100%;
`;

export const Message = styled(BaseMessage)<{hasButtons?: boolean}>`
  margin: 40px 34px 40px 46px;
  box-shadow: 0 1px 3px 0 rgba(0 0 0 / 20%);
  padding-bottom: ${({hasButtons, theme}) => (hasButtons ? 0 : theme.spacing.s2)};
  border-radius: ${({theme}) => theme.borderRadius.br2};
  border-top-left-radius: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -12px;
    width: 12px;
    height: 12px;

    ${({theme}) => css`
      background: linear-gradient(
        45deg,
        transparent 40%,
        rgba(0 0 0 / 20%) 50%,
        ${theme.palette.white} 50%,
        ${theme.palette.white} 100%
      );
    `};
  }
`;

export const AllButtonsWrapper = styled.div`
  width: 100%;
  border: transparent solid;

  ${({
    theme: {
      palette,
      spacing: {s10, s05},
    },
  }) => css`
    background-color: ${palette.grey400};
    border-width: ${s10} ${s05} ${s05} ${s05};
    border-bottom-color: ${palette.grey100};
  `};
`;

export const AllButtons = styled.div`
  ${mixins.wh('100%')};
  ${mixins.stack({size: '5'})};
  position: relative;
  padding: 52px 6px 16px;
  font-weight: 500;

  ${({theme}) => css`
    background-color: ${theme.palette.white};
    border-radius: ${theme.spacing.s8} ${theme.spacing.s8} 0 0;
  `};

  &::before {
    ${mixins.wh('40px', '4px')};
    position: absolute;
    top: 16px;
    left: calc(50% - 20px);
    display: block;
    content: '';
    background-color: ${({theme}) => theme.palette.grey400};
    border-radius: 6px;
  }
`;

export const Title = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
`;

export const CloseIcon = styled(BaseCloseIcon)`
  position: absolute;
  left: ${({theme}) => theme.spacing.s4};
  color: ${({theme}) => theme.palette.grey500};
`;

export const ListButton = styled.div`
  ${mixins.wh('100%', '40px')};
  ${mixins.stack({size: '2', align: 'center', direction: 'ROW'})};
  padding: 0 18px;
`;
